<template>
  <div class="orderManage">
    <div class="orderManage-list">

      <div
        class="orderManage-item"
        v-for="item in reservationList"
        :key="item.work_id"
      >
        <div class="orderManage-item-title">
          {{ item.reservation_type }}
        </div>
        <div class="orderManage-item-option">
          <div class="orderManage-item-label">
            预约日期：
          </div>
          <div class="orderManage-item-content">
            {{ item.booking_time }}
          </div>
        </div>
        <div class="orderManage-item-option">
          <div class="orderManage-item-label">
            预约状态：
          </div>
          <div class="orderManage-item-content">
            {{ item.booking_status_name }}
          </div>
        </div>
        <div
          class="orderManage-item-option"
          v-if="item.work_type === 'neijing'"
        >
          <div class="orderManage-item-label">
            检查项目：
          </div>
          <div class="orderManage-item-content">
            {{ item.project_name }}
          </div>
        </div>
        <div
          class="orderManage-item-option"
          v-if="item.work_type === 'tijian'"
        >
          <div class="orderManage-item-label">
            套餐名称：
          </div>
          <div class="orderManage-item-content">
            {{ item.project_name }}
          </div>
        </div>
        <div
          class="orderManage-item-option"
          v-if="item.work_type === 'neijing' || item.work_type === 'tijian'"
        >
          <div class="orderManage-item-label">
            备注内容：
          </div>
          <div class="orderManage-item-content">
            {{ item.remark }}
          </div>
        </div>
        <div class="orderManage-item-action">
          <el-button
            v-show="type === 'cancel' && item.booking_status === 0 && item.work_type"
            type="danger"
            size="mini"
            @click="cancel(item)"
          >取消预约</el-button>
          <el-button
            v-show="type === 'edit' && item.booking_status === 0 && item.work_type"
            type="danger"
            size="mini"
            @click="modify(item)"
          >修改预约</el-button>
          <el-button
            type="danger"
            size="mini"
            @click="notify(item)"
          >通知</el-button>
        </div>
      </div>

    </div>
    <div class="booking-management-action">
      <el-button
        type="danger"
        @click="notify(null)"
      >一键通知</el-button>
      <el-button
        type="danger"
        v-if="type === 'edit'"
        @click="modify(null)"
      >一键修改</el-button>
      <el-button
        type="danger"
        v-else
        @click="cancelAll"
      >一键取消</el-button>
    </div>
    <van-popup
      v-model="popupInfo.show"
      position="bottom"
    >
      <div class="booking-home-search">
        <div class="booking-home-search-header">
          <div @click="popupInfo.show = false">
            取消
          </div>
          <div class="booking-home-search-title">
            {{ popupInfo.title }}
          </div>
          <div
            class="booking-submit"
            @click="submit"
          >
            确定
          </div>
        </div>
        <div class="booking-division" />

        <div class="booking-home-search-list">
          <van-field
            v-model="popupInfo.content"
            rows="8"
            label=""
            type="textarea"
            :placeholder="popupInfo.placeholder"
          />
        </div>
      </div>
    </van-popup>
    <van-overlay
      :show="submiting"
      z-index="9999"
    >
      <van-loading type="spinner" />
    </van-overlay>
  </div>
</template>

<script>
import bookingService from "@/apis/booking";
import enums from "@/views/booking/mixins/enums";
import { Toast } from "vant";

export default {
  data() {
    return {
      popupInfo: {
        title: "取消预约",
        placeholder: "请输入取消预约的原因",
        content: "",
        show: false,
        type: "", // notify 通知 cancel 取消预约
      },
      type: "edit", // edit 编辑 cancel 取消
      reservationList: [],
      currentInfo: null,
      submiting: false,
    };
  },
  mixins: [enums],

  created() {
    this.type = this.$route.query.type;
    this.bookReservationList();
  },
  methods: {
    submit() {
      const { popupInfo } = this;
      if (popupInfo.type === "notify") {
        this.messageReply();
      } else if (popupInfo.type === "cancel") {
        this.cancelConfirm();
      }
    },
    messageReply() {
      const { currentUserInfo, currentInfo, popupInfo } = this;

      if (!popupInfo.content) {
        Toast("请输入回复内容");
        return;
      }
      const params = {
        // work_type: currentInfo.work_type,
        // work_id: currentInfo.work_id,
        message_content: popupInfo.content,
        user_id: currentUserInfo.user_id,
        user_name: currentUserInfo.user_name,
        ...currentInfo,
      };
      this.submiting = true;
      bookingService
        .messageReply(params)
        .then(() => {
          Toast("提交成功");
          this.popupInfo.show = false;
          this.submiting = false;
        })
        .catch(() => {
          this.submiting = false;
        });
    },
    bookReservationList() {
      const params = {
        apply_id: this.$route.query.id,
      };
      bookingService.bookReservationList(params).then((res) => {
        this.reservationList = res;
        console.log(res);
      });
    },
    notify(item) {
      if (item) {
        this.currentInfo = {
          ...item,
          is_all: 0,
        };
      } else {
        this.currentInfo = {
          apply_id: this.$route.query.id,
          is_all: 1,
          work_type: "",
          work_id: 0,
        };
      }
      this.popupInfo = {
        title: "通知",
        placeholder: "请输入需要通知的内容",
        content: "",
        show: true,
        type: "notify",
      };
    },
    cancelAll() {
      const { reservationList } = this;
      if (
        reservationList.some(
          (item) => item.booking_status !== 0 && item.work_type
        )
      ) {
        Toast("当前工单中部分项目已被跟进，不支持一键取消，请通知相应部门跟进");
        return;
      }
      this.cancel();
    },
    modify(item) {
      const query = this.$route.query;
      const { reservationList } = this;
      if (
        !item &&
        reservationList.some(
          (item) => item.booking_status !== 0 && item.work_type
        )
      ) {
        Toast("当前工单中部分项目已被跟进，不支持一键修改，请通知相应部门跟进");
        return;
      }
      let params = {};
      if (item) {
        params = {
          work_type: item.work_type,
          is_all: 0,
          work_id: item.work_id,
        };
      } else {
        params = {
          is_all: 1,
          work_id: 0,
        };
      }
      params = {
        ...params,
        is_puke: 0,
        his_package_id: query.his_package_id,
        apply_id: query.id,
      };
      this.$router.push({
        name: "BookingPlan",
        query: params,
      });
    },
    cancel(item) {
      if (item) {
        this.currentInfo = {
          ...item,
          is_all: 0,
        };
      } else {
        this.currentInfo = {
          apply_id: this.$route.query.id,
          is_all: 1,
          work_id: 0,
        };
      }
      this.currentInfo.is_puke = 0;
      this.currentInfo.is_send_msg = 0;

      this.popupInfo = {
        title: "取消预约",
        placeholder: "请输入取消预约的原因",
        content: "",
        show: true,
        type: "cancel",
      };
    },
    cancelConfirm() {
      const { currentInfo, popupInfo, currentUserInfo } = this;
      const params = {
        puke_cancel_reason: popupInfo.content,
        ...currentInfo,
        SubmitUserId: currentUserInfo.user_id,
        SubmitUser: currentUserInfo.user_name,
      };
      bookingService.bookReservationCancel(params).then(() => {
        Toast("取消成功");
        this.popupInfo.show = false;
        this.bookReservationList();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.orderManage {
  padding: 20px;

  .orderManage-list {
    .orderManage-item {
      border: 1px solid #ebedf0;
      border-radius: 5px;
      padding: 20px;
      position: relative;
      margin-bottom: 10px;
      .orderManage-item-title {
        font-size: 16px;
        font-weight: bold;
        line-height: 30px;
        margin-bottom: 24px;
      }
      .orderManage-item-option {
        display: flex;
        margin-bottom: 10px;
        .orderManage-item-label {
          width: 80px;
          text-align: right;
          margin-right: 0px;
          flex-shrink: 0;
        }
        .orderManage-item-content {
          flex: 1;
        }
      }
    }
    .orderManage-item-action {
      display: flex;
      flex-direction: column;
      margin-top: 10px;
      position: absolute;
      right: 5px;
      top: 0;
      .el-button {
        margin-bottom: 10px;
        margin-left: 0;
      }
    }
  }
}
.booking-management-action {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;

  .el-button {
    margin-left: 0;
    margin-bottom: 20px;
    width: 70%;
  }
}
</style>